import { createSlice } from "@reduxjs/toolkit";
import {
    createBannerThunk,
    deleteBannerThunk,
    fetchBannersThunk,
    updateBannerThunk
} from "./bannersThunk";

const bannersSlice = createSlice({
    name: "banners",
    initialState: {
        items: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBannersThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBannersThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchBannersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(createBannerThunk.fulfilled, (state, action) => {
                const newBanner = action.payload;
                state.items = [newBanner, ...state.items];
            })

            .addCase(updateBannerThunk.fulfilled, (state, action) => {
                const updatedBanner = action.payload;
                state.items = state.items.map((e) => {
                    if (e.id === updatedBanner.id) {
                        return updatedBanner;
                    } else {
                        return e;
                    }
                });
            })

            .addCase(deleteBannerThunk.fulfilled, (state, action) => {
                const deletedBannerId = action.payload;
                state.items = state.items.filter((e) => e.id !== deletedBannerId);
            });
    }
});

export default bannersSlice.reducer;
